import { Template, TemplateType } from '../../types';

// Mock Templates
export const mockTemplates: Template[] = [
  {
    id: '1',
    name: 'Standard Lease Abstract Template',
    type: TemplateType.Report,
    content: 'Template content here...',
    createdBy: '1',
    createdDate: '2023-01-10T09:00:00Z',
  },
  {
    id: '2',
    name: 'Retail Investment Memo Template',
    type: TemplateType.Memo,
    content: 'Template content here...',
    createdBy: '1',
    createdDate: '2023-01-12T11:30:00Z',
  },
];
